var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationComingSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 180,
    viewBox: "0 0 181 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90.335,
    cy: 90,
    r: 90,
    fill: "#F8F8F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8695_3145)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M119.067 132.192C118.85 132.235 118.611 132.279 118.351 132.322V129.587C115.551 131.215 107.412 131.671 94.6504 128.611C92.2413 128.025 90.4182 125.876 90.4833 123.402C90.4833 123.359 90.4833 123.337 90.4833 123.337L91.3949 96.9019C91.5251 91.3024 97.385 86.354 100.575 81.7312C105.784 74.0481 109.626 71.1833 115.095 59.3331C115.442 58.5518 115.768 57.7705 116.072 56.9891C90.4182 62.9142 66.3924 51.3896 60.5975 48.3945C61.7695 52.7569 66.5877 62.9793 68.541 67.0813C73.2941 71.8995 75.5079 79.1918 83.842 87.1353C86.2511 89.4142 87.6835 92.5395 87.7486 95.8602L88.5951 119.495C88.5951 120.472 88.3998 121.384 88.0742 122.165C87.1627 124.509 84.5582 125.681 82.084 125.225C68.1504 122.49 61.6393 129.197 61.2486 129.587C59.2302 136.294 58.1885 143.326 58.1885 150.423H121.411V150.227C121.411 144.107 120.63 138.052 119.067 132.192Z",
    fill: "#6CAFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6049 86.4834L72.7081 73.3311C63.3322 60.7648 58.2536 45.5289 58.1885 29.9024V29.707H121.411C121.411 45.3987 116.332 60.6996 106.891 73.266L96.9944 86.4834C95.4317 88.5669 95.4317 91.4969 96.9944 93.5805L106.826 106.733C116.267 119.299 121.346 134.535 121.411 150.227V150.422H58.1885C58.1885 134.665 63.2671 119.429 72.7081 106.798L82.6049 93.5805C84.1676 91.4969 84.1676 88.5669 82.6049 86.4834Z",
    stroke: "white",
    strokeWidth: 3.25553,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5828 33.7423H123.949C126.228 33.7423 128.051 31.9193 128.051 29.7055C128.051 27.4266 126.228 25.6035 123.949 25.6035H55.5828C53.369 25.6035 51.5459 27.4266 51.5459 29.7055C51.5459 31.9193 53.369 33.7423 55.5828 33.7423Z",
    fill: "#28519E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.949 146.32H55.5828C53.369 146.32 51.5459 148.143 51.5459 150.422C51.5459 152.636 53.369 154.459 55.5828 154.459H123.949C126.228 154.459 128.051 152.636 128.051 150.422C128.051 148.143 126.228 146.32 123.949 146.32Z",
    fill: "#28519E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8695_3145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.8305,
    height: 128.919,
    fill: "white",
    transform: "translate(51.416 25.541)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationComingSoon);
export default __webpack_public_path__ + "static/media/IllustrationComingSoon.4fe6142d3593a0218b8b9a26bb368bcd.svg";
export { ForwardRef as ReactComponent };